import React from 'react';

const ResultsIcon = ({ fill, width, ...rest }: SvgIconProps) => (
    <svg className="icon results-icon" width={width} height={width} viewBox="0 0 20 18" {...rest}>
        <path
            fill={fill}
            fillRule="evenodd"
            d="M19.761 8.701c.276.257.315.672.107.973l-.07.087-7.45 8c-.26.281-.686.315-.988.097l-.086-.073-3.05-3c-.295-.29-.3-.766-.009-1.06.264-.27.68-.297.976-.082l.085.072 2.5 2.46 6.925-7.436c.282-.303.757-.32 1.06-.038zM2.75 13.5c.414 0 .75.336.75.75s-.336.75-.75.75h-2c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2zm0-6.75c.414 0 .75.336.75.75s-.336.75-.75.75h-2C.336 8.25 0 7.914 0 7.5s.336-.75.75-.75h2zm9.5 0c.414 0 .75.336.75.75s-.336.75-.75.75h-5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h5zM2.75 0c.414 0 .75.336.75.75s-.336.75-.75.75h-2C.336 1.5 0 1.164 0 .75S.336 0 .75 0h2zm16.5 0c.414 0 .75.336.75.75s-.336.75-.75.75h-12c-.414 0-.75-.336-.75-.75S6.836 0 7.25 0h12z"
            transform="translate(-30 -706) translate(0 315) translate(20) translate(0 378) translate(10 10) translate(0 3)"
        />
    </svg>
);

export default ResultsIcon;
